import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Projects.css';
import TcgMeLogo from './TcgMeLogo';

const Projects = () => {
  const navigate = useNavigate();
  
  const projects = [
    {
      id: 1,
      title: "SmartCloset",
      description: "An intelligent wardrobe management system that helps users organize their clothing and create new outfits",
      technologies: ["Python", "FastAPI", "React", "Mask R-CNN", "TensorFlow", "JavaScript"],
      githubUrl: "#",
      liveUrl: "#",
      image: "👕",
      path: "/smartcloset"
    },
    {
      id: 2,
      title: "TcgMe",
      description: "A collectible card app that transforms your photos into unique, AI-generated trading cards.",
      technologies: ["React", "JavaScript", "OpenAI API", ".NET"],
      githubUrl: "#",
      liveUrl: "#",
      image: "tcgme-logo",
      path: "/tcgme"
    },
    {
      id: 3,
      title: "Journey To Mars",
      description: "A 3D golf game created for a 6-hour hackathon, featuring realistic physics and space-themed gameplay",
      technologies: ["React", "React Three Fiber", "JavaScript", "3D Web Graphics"],
      githubUrl: "#",
      liveUrl: "#",
      image: "⛳",
      path: "/journeytomars"
    },
    {
      id: 4,
      title: "RecipeBook",
      description: "A full-stack web application for managing recipes with secure user authentication and dynamic search",
      technologies: ["Django", "HTML", "CSS", "JavaScript"],
      githubUrl: "#",
      liveUrl: "#",
      image: "📖",
      path: "/recipebook"
    },
    {
      id: 5,
      title: "Sprite Editor",
      description: "A comprehensive pixel art and animation tool built with C++ and Qt, following agile development practices",
      technologies: ["C++", "Qt Creator", "Qt Framework", "JSON"],
      githubUrl: "#",
      liveUrl: "#",
      image: "🎨",
      path: "/spriteeditor"
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h1 className="projects-title">My Projects</h1>
        <div className="projects-grid">
          {projects.map(project => (
            <div 
              key={project.id} 
              className="project-card clickable"
              onClick={() => navigate(project.path)}
            >
              <div className="project-image">
                {project.image === "tcgme-logo" ? (
                  <TcgMeLogo className="project-logo" />
                ) : (
                  <span className="project-icon">{project.image}</span>
                )}
              </div>
              <div className="project-content">
                <h3 className="projects-card-title">{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
